import styled from 'styled-components';

import { TextStyle } from 'components/text';

export const Main = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 5px;

  ${TextStyle} {
    color: currentColor;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
  width: 18px;
  height: 18px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
